import { LuInfo } from 'react-icons/lu'

const OperationsDisclaimer = () => {
  return (
    <div className='bg-gradient-to-bl from-helpers-info-main to-helpers-info-button p-4 text-xs text-blue-100'>
      <LuInfo className='mb-2 h-6 w-6 text-white' />
      <div>
        <strong>Please Note: </strong> Information contained within this
        application is for operational purposes and not to be used for any
        business reporting
      </div>
    </div>
  )
}

export default OperationsDisclaimer
